export interface StockEnquiryPurchaseOrder {
  id: string;
  type: string;
  purchaseOrderHeaderId: string;
  orderNo: string;
  supplierKey: string;
  supplierName: string;
  supplierCurrency: string;
  quantity: number;
  unitOfMeasure: string;
  deliveredQuantity: number;
  balanceToDeliver: number;
  price: number;
  allocatedQuantity: number;
  processedQuantity: number;
  dueDate: Date;
  orderStatus: string;
  colour: string;
  sequence: number;
  productKey: string;
  commentsExist: boolean;
  promisedDate: Date;
  selected: boolean;
}
